import { STORAGE_KEYS as o } from "./storage-manager.js";
export function getAlias(e) {
  const t = null == e ? void 0 : e.j(o.C._E);
  let n;
  return t && (n = { label: t.l, name: t.a }), n;
}
